import type { ProductCardResponse, ProductCategory } from '../../types';
import styles from './ProductCard.module.css';

type NormalizedCategory = {
    category: { id: number; name: string };
    section?: { id: number; name: string } | null;
};

interface ProductCategoriesProps {
    categories?: ProductCardResponse['categories'] | ProductCategory[];
    onRemoveClick?: (categoryId: number, categoryName: string, e: React.MouseEvent) => void;
    isRemoving?: boolean;
}

export default function ProductCategories({
    categories,
    onRemoveClick,
    isRemoving = false,
}: ProductCategoriesProps) {

    if (!categories || categories.length === 0) {
        return (
            <div className={styles.productCardCategoryInfo}>
                <span className={styles.productCardNoCategory}>Товара нет в категории</span>
            </div>
        );
    }

    // Нормализуем данные для работы с обоими типами
    const normalizedCategories: NormalizedCategory[] = categories.map((cat) => {
        // Если это ProductCategory (из Product) - имеет поле categoryId и category
        if ('categoryId' in cat && 'category' in cat) {
            const productCategory = cat as ProductCategory;
            if (!productCategory.category) {
                // Если category отсутствует, используем categoryId
                return {
                    category: {
                        id: productCategory.categoryId,
                        name: `Категория #${productCategory.categoryId}`,
                    },
                    section: null,
                };
            }
            return {
                category: {
                    id: productCategory.category.id,
                    name: productCategory.category.name,
                },
                section: null,
            };
        }
        // Если это уже ProductCardResponse формат
        return cat as NormalizedCategory;
    });

    return (
        <div className={styles.productCardCategoryInfo}>
            {normalizedCategories.map((cat, index) => (
                <div key={index} className={styles.productCardCategoryItem}>
                    {/* {cat.section?.name && (
                        <>
                            <span>{cat.section.name}</span>
                            <span className={styles.productCardCategorySeparator}> - </span>
                        </>
                    )} */}
                    <span>{cat.category.name}</span>
                    {onRemoveClick && normalizedCategories.length > 1 && (
                        <button
                            className={styles.productCardCategoryRemove}
                            onClick={(e) => onRemoveClick(cat.category.id, cat.category.name, e)}
                            title="Удалить из категории"
                            disabled={isRemoving}
                        >
                            ×
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}

